export const getJuranconData = () => ({
  name: "Jurançon",
  region: "Sud-Ouest",
  country: "France",
  description: "Jurançon est une appellation prestigieuse du Sud-Ouest de la France, célèbre pour ses vins blancs secs et moelleux de grande qualité. Cette région bénéficie d'un terroir montagneux unique et d'une longue tradition viticole.",
  type: "subregion",
  area: "1,000 ha",
  production: "40,000 hectolitres",
  mapAreas: [
    { region: "Jurançon", x: -0.5, y: 43.2, color: "#4B164C", size: 3 }
  ],
  characteristics: {
    climate: "Climat océanique avec influence montagneuse, étés chauds, hivers frais",
    soil: "Sols d'argile et de calcaire, excellente structure",
    viticulture: "Viticulture traditionnelle, vendanges manuelles"
  },
  wineStyles: {
    white: "Vins blancs secs et moelleux, aromatiques et complexes",
    sweet: "Vins blancs moelleux et complexes, avec une belle acidité"
  },
  history: "La viticulture à Jurançon remonte à l'époque romaine. Au Moyen Âge, les vins de Jurançon étaient très appréciés. Le cépage Petit Manseng est devenu le cépage emblématique de la région. Aujourd'hui, Jurançon est reconnue pour ses vins blancs de qualité et son identité terroir unique.",
  foodPairing: "Poissons, volailles, fromages, desserts, foie gras, cuisine du Sud-Ouest",
  grapeVarieties: [
    {
      name: "Petit Manseng",
      percentage: "50%",
      description: "Cépage emblématique de Jurançon, pour vins secs et moelleux",
      characteristics: "Aromatique, acidité vive, notes d'agrumes et de fruits exotiques",
      wineStyles: "Sec à moelleux, moyen-corps, aromatique"
    },
    {
      name: "Gros Manseng",
      percentage: "30%",
      description: "Cépage d'assemblage, apportant structure et acidité",
      characteristics: "Structuré, acidité vive, notes d'agrumes",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Courbu",
      percentage: "20%",
      description: "Cépage local, apportant complexité et rondeur",
      characteristics: "Complexe, rondeur, notes de miel",
      wineStyles: "Sec à moelleux, moyen-corps, complexe"
    }
  ],
  subregions: {
    "jurancon-sec": {
      name: "Jurançon Sec",
      description: "Zone de production des vins blancs secs",
      characteristics: {
        climate: "Climat océanique tempéré",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        white: ["Petit Manseng", "Gros Manseng", "Courbu"]
      },
      wineStyles: {
        white: "Vins blancs secs et aromatiques"
      },
      foodPairing: "Poissons, volailles, fromages"
    },
    "jurancon-moelleux": {
      name: "Jurançon Moelleux",
      description: "Zone de production des vins blancs moelleux",
      characteristics: {
        climate: "Climat favorable à la surmaturation",
        soil: "Sols argilo-calcaires",
        viticulture: "Viticulture traditionnelle"
      },
      grapeVarieties: {
        white: ["Petit Manseng", "Courbu"]
      },
      wineStyles: {
        sweet: "Vins blancs moelleux et complexes"
      },
      foodPairing: "Foie gras, desserts, fromages bleus"
    }
  }
}); 